// @ts-nocheck
import { Box, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { CustomButtonComponent } from "../../../components/Custom/AlertDialog";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { getUniversalDateTimeFormat } from "../../../utils/methods/universalDateTimeFormat";
import { DeleteOutline, OpenInNew } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useState } from "react";
import { useEffect } from "react";
import { isUserRole, isActiveRole } from "../../../utils/methods/storeFunc";
import { USER_ROLES } from "../../../staticData/userRoles";

const OpportunityContainer = ({
  messageStr,
  contractorsList,
  onAnyway,
  onAnywayBtnTitle = "Send Anyway",
  title,
  onDelete,
  conflictType,
}) => {
  const [contList, setContList] = useState(contractorsList);

  useEffect(() => {
    setContList(contractorsList);
  }, [contractorsList]);

  function deleteHandler(type, cId, pId) {
    onDelete(type, cId, pId);
    setContList((prev) => {
      return prev?.filter((item) => {
        return !(item?.id === cId && item?.Id === pId);
      });
    });
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "0.5rem",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "0.1rem" }}>
        <Typography sx={{ fontSize: "1.25rem", fontWeight: "500" }}>
          {title}
        </Typography>
        <Typography>{messageStr}</Typography>
      </Box>
      {contList?.length > 0 && (
        <Box
          sx={{
            marginX: "auto",
            width: "100%",
          }}
        >
          <DataTable
            data={contList}
            onDelete={deleteHandler}
            type={conflictType}
            enableDelete={
              onDelete &&
              isUserRole(
                USER_ROLES.SUPERADMIN,
                USER_ROLES.ADMIN,
                USER_ROLES.COORDINATOR,
              )
            }
          />
        </Box>
      )}

      {onAnyway ? (
        <Box sx={{ textAlign: "right", width: "100%" }}>
          <CustomButtonComponent onClick={onAnyway}>
            {onAnywayBtnTitle}
          </CustomButtonComponent>
        </Box>
      ) : null}
    </Box>
  );
};

OpportunityContainer.propTypes = {
  messageStr: PropTypes.string,
  title: PropTypes.string,
  onAnywayBtnTitle: PropTypes.string,
  contractorsList: PropTypes.arrayOf(
    PropTypes.shape({
      positionName: PropTypes.string,
      name: PropTypes.string,
      startDate: PropTypes.string,
    }),
  ),
  onAnyway: PropTypes.func,
  onDelete: PropTypes.func,
  conflictType: PropTypes.string,
};

export function DataTable({ data = [], enableDelete, onDelete, type }) {
  const { userId } = useSelector((state) => state?.auth);
  const { pathname } = useLocation();
  const border = getCssVariableHandler({ variableName: "--primary-pink-hex" });

  // if (!data?.length) return null;

  const hasEventColumn = data.some((item) => item?.assignedRoles?.length > 0);
  const hasContractorName = data.some(
    (item) => item?.preferredName || item?.name,
  );

  if (type == "Backup") {
    return (
      <Table
        sx={{
          borderCollapse: "collapse",
          width: "100%",
          textAlign: "center",
          color: "white",
          "& td, & th": {
            padding: "0.25rem",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Event Name
            </TableCell>
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Session
            </TableCell>
            {hasContractorName && (
              <TableCell
                sx={{
                  border: `1px solid ${border}`,
                  backgroundColor: "#444",
                  color: "white",
                  textAlign: "center",
                }}
              >
                Contractor Name
              </TableCell>
            )}
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Start Date
            </TableCell>
          </TableRow>
        </TableHead>
        {data?.length == 0 ? (
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={10}
                sx={{
                  border: `1px solid ${border}`,
                  color: "white",
                  textAlign: "center",
                }}
              >
                No Records
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {data?.map((item, index) => (
              <TableRow key={item?._id ?? Math.random()}>
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {item?.eventName}
                </TableCell>
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {item?.sessionName}
                </TableCell>
                {hasContractorName && (
                  <TableCell
                    sx={{
                      border: `1px solid ${border}`,
                      color: "white",
                      textAlign: "center",
                    }}
                  >
                    {(item?.preferredName || item?.name) ?? "N/A"}
                  </TableCell>
                )}
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {getUniversalDateTimeFormat({
                    dateTime: item?.startDate ?? item?.Date,
                  }) ?? "N/A"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    );
  }

  if (type == "Restricted") {
    return (
      <Table
        sx={{
          borderCollapse: "collapse",
          width: "100%",
          textAlign: "center",
          color: "white",
          "& td, & th": {
            padding: "0.25rem",
          },
        }}
      >
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Contractor Name
            </TableCell>
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Remark
            </TableCell>

            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Restricted By
            </TableCell>
          </TableRow>
        </TableHead>
        {data?.length == 0 ? (
          <TableBody>
            <TableRow>
              <TableCell
                colSpan={10}
                sx={{
                  border: `1px solid ${border}`,
                  color: "white",
                  textAlign: "center",
                }}
              >
                No Records
              </TableCell>
            </TableRow>
          </TableBody>
        ) : (
          <TableBody>
            {data?.map((item, index) => (
              <TableRow key={item?._id ?? Math.random()}>
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {(item?.preferredName || item?.name) ?? "N/A"}
                </TableCell>
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {item?.restrictedRemark || "N/A"}
                </TableCell>
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {item?.restrictedBy?.name || "N/A"}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    );
  }

  return (
    <Table
      sx={{
        borderCollapse: "collapse",
        width: "100%",
        textAlign: "center",
        color: "white",
        "& td, & th": {
          padding: "0.25rem",
        },
      }}
    >
      <TableHead>
        <TableRow>
          <TableCell
            sx={{
              border: `1px solid ${border}`,
              backgroundColor: "#444",
              color: "white",
              textAlign: "center",
            }}
          >
            Position Name
          </TableCell>
          {hasContractorName && (
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Contractor Name
            </TableCell>
          )}
          <TableCell
            sx={{
              border: `1px solid ${border}`,
              backgroundColor: "#444",
              color: "white",
              textAlign: "center",
            }}
          >
            Start Date
          </TableCell>
          {hasEventColumn && (
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              {"Assinged Role & Event"}
            </TableCell>
          )}

          {enableDelete && (
            <TableCell
              sx={{
                border: `1px solid ${border}`,
                backgroundColor: "#444",
                color: "white",
                textAlign: "center",
              }}
            >
              Remove Opportunity
            </TableCell>
          )}
        </TableRow>
      </TableHead>
      {data?.length == 0 ? (
        <TableBody>
          <TableRow>
            <TableCell
              colSpan={10}
              sx={{
                border: `1px solid ${border}`,
                color: "white",
                textAlign: "center",
              }}
            >
              No Records
            </TableCell>
          </TableRow>
        </TableBody>
      ) : (
        <TableBody>
          {data?.map((item, index) => (
            <TableRow key={item?._id ?? Math.random()}>
              <TableCell
                sx={{
                  border: `1px solid ${border}`,
                  color: "white",
                  textAlign: "center",
                }}
              >
                {`${item?.positionName} ${item?.positionOrder ? `-${item?.positionOrder}` : ""}` ??
                  "N/A"}
              </TableCell>
              {hasContractorName && (
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  {(item?.preferredName || item?.name) ?? "N/A"}
                </TableCell>
              )}
              <TableCell
                sx={{
                  border: `1px solid ${border}`,
                  color: "white",
                  textAlign: "center",
                }}
              >
                {getUniversalDateTimeFormat({
                  dateTime: item?.startDate ?? item?.Date,
                }) ?? "N/A"}
              </TableCell>
              {hasEventColumn && (
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.25rem",
                  }}
                >
                  {item?.assignedRoles?.map((role, i) => (
                    <Box
                      key={i}
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "0.5rem",
                        color: "white",
                        "&:hover": isActiveRole(USER_ROLES.FREELANCE_EC)
                          ? {}
                          : {
                              color: getCssVariableHandler({
                                variableName: "--primary-pink-hex",
                              }),
                            },
                      }}
                    >
                      {role?.assignedPositionName
                        ? `${role?.assignedPositionName} - ${role?.eventName}`
                        : "-"}

                      {role?.eventId && !isActiveRole(USER_ROLES.FREELANCE_EC) ? (
                        <IconButton
                          sx={{
                            background: border,
                            padding: "4px",
                            borderRadius: "5px",
                            color: "white",
                            marginLeft: "0.5rem",
                            "&:hover": {
                              background: border,
                            },
                          }}
                          disabled={!role?.eventId}
                          onClick={() => {
                            if (!role?.eventId) return;
                            window.open(
                              `${pathname}?email=true&redirect='/event/details'&userId=${userId}&data=${btoa(JSON.stringify({ id: role?.eventId, tab: 2 }))}`,
                            );
                          }}
                        >
                          <OpenInNew sx={{ fontSize: "1rem" }} />
                        </IconButton>
                      ) : null}
                    </Box>
                  ))}
                </TableCell>
              )}
              {enableDelete && (
                <TableCell
                  sx={{
                    border: `1px solid ${border}`,
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <IconButton
                    onClick={() => {
                      if (!item?.id && !item?.Id) return;
                      onDelete(type, item.id, item?.Id);
                    }}
                    sx={{
                      background: border,
                      padding: "4px",
                      borderRadius: "5px",
                      color: "white",
                      "&:hover": {
                        background: border,
                      },
                    }}
                    disabled={!item?.id}
                  >
                    <DeleteOutline sx={{ fontSize: "1rem" }} />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      )}
    </Table>
  );
}

DataTable.propTypes = {
  data: PropTypes.array,
  enableDelete: PropTypes.bool,
  onDelete: PropTypes.func,
  type: PropTypes.string,
};

export default OpportunityContainer;